import React, { useState, useEffect } from 'react';
import { Observer } from 'mobx-react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import {
  Typography,
  Tabs,
  Tab,
  Container,
  Divider,
  colors,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { FlexDiv, StandardBox } from '../../styles/styles';
import { useRootStore } from '../../../stores/BridgeProvider';
import OrgSettings from '../OrgSettings';
import Spinner from '../../util/Spinner';
import OrgManage from '../OrgManage';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  tabs: {
    marginTop: theme.spacing(3),
  },
  divider: {
    backgroundColor: colors.grey[300],
  },
  content: {
    marginTop: theme.spacing(3),
  },
}));

const OrgPage = () => {
  const history = useHistory();
  const classes = useStyles();
  const { tab: currentTab } = useParams();
  const tabs = [
    { value: '/organization/manage', label: 'Management' },
    {
      value: '/organization/settings',
      label: 'Settings',
    },
  ];
  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  if (!currentTab) {
    return <Redirect to="/organization/manage" />;
  }

  return (
    <Observer
      render={() => {
        const { orgStore, dataStore } = useRootStore();
        const [isLoading, setLoading] = useState(true);
        const accounts = dataStore.validAccountArray;

        useEffect(() => {
          const getOrg = async () => {
            await orgStore.retrieveOrgUsers();
          };
          const initialCalls = async () => {
            const requests = [getOrg()];

            if (accounts.length === 0) {
              requests.push(dataStore.retrieveAccounts());
            }
            await Promise.all(requests);
            setLoading(false);
          };
          initialCalls();
        }, []);
        if (isLoading) return <Spinner />;
        return (
          <FlexDiv style={{ justifyContent: 'flex-start', marginTop: '2rem' }}>
            <StandardBox style={{ minHeight: 'auto', marginBottom: '1rem' }}>
              <Typography variant="h2">Organization Settings</Typography>
            </StandardBox>
            <div>
              <Container maxWidth="lg">
                <Tabs
                  className={classes.tabs}
                  onChange={handleTabsChange}
                  scrollButtons="auto"
                  value={`/organization/${currentTab}`}
                  variant="scrollable"
                  aria-label="simple tabs example"
                  indicatorColor="primary"
                >
                  {tabs.map(tab => (
                    <Tab key={tab.value} label={tab.label} value={tab.value} />
                  ))}
                </Tabs>
                <Divider className={classes.divider} />
                <div className={classes.content}>
                  {currentTab === 'manage' && <OrgManage />}
                  {currentTab === 'settings' && <OrgSettings />}
                </div>
              </Container>
            </div>
          </FlexDiv>
        );
      }}
    />
  );
};

export default OrgPage;
